import { Button, Container, Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import LayoutWithPageLoading from 'Components/layout/LayoutWithPageLoading';
import ArticleCard from 'Features/Article/ArticleCard';
import useAsyncTask from 'hooks/useAsyncTask';
import { OWeeklyTech } from 'Models/WeeklyTech';
import { WeeklyTechState } from 'Models/WeeklyTech/@types';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxStore } from 'stores';
import { TDispatch } from 'Typings/Global';

type StoreSelection = Pick<WeeklyTechState, 'list'>;

export interface WeeklyTechDashboardProps { }

const WeeklyTechDashboard: FC<WeeklyTechDashboardProps> = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch<TDispatch>();
    const { list: weeklyTechList = [] } = useSelector<ReduxStore, StoreSelection>(({ WeeklyTech: { list } }) => ({ list }));
    const getDataTask = useAsyncTask(async () => await dispatch(OWeeklyTech.getItemsList({ filter: { order: "created DESC" } })));
    const handleAdd = () => dispatch(OWeeklyTech.showWeeklyTechForm({}));

    useEffect(() => {
        getDataTask.run()
        //eslint-disable-next-line
    }, [])

    return (
        <LayoutWithPageLoading loading={getDataTask.status === "PROCESSING"} >
            <Button size={'large'} variant={'contained'} onClick={handleAdd} color="primary" className={classes.addButton} >Add New</Button>
            <Container className={classes.root} >
                <Grid container spacing={3} >
                    {
                        weeklyTechList.map((item) => {
                            return (
                                <Grid item key={item.id} >
                                    <ArticleCard article={item} />
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Container>
        </LayoutWithPageLoading>
    )
}

const useStyles = makeStyles((theme) => {
    return (createStyles({
        root: {
            display: 'flex',
            padding: 20,
            paddingTop: 64,
            flex: 1
        },
        container: {
            display: 'flex',
            flexWrap: 'wrap',
            width: 960,
            margin: 'auto',
            marginTop: 64
        },
        addButton: {
            position: 'fixed',
            right: 24, top: 64 + 24
        },
    }))
})

export default WeeklyTechDashboard